module.exports = __webpack_public_path__ + "media/images/flags/4x3/bih-43bcce38ab7870b0e68d24ad954c2d00.svg";